import { Box, Typography } from '@mui/material'
import { useAppSelector } from 'utils/custom-hooks/useTypedReduxStore'
import useGetPricePrepend from 'utils/custom-hooks/useGetPricePrepend'
import { setDecimalPrecision } from 'utils/helpers'

export const ToAllocateAmountText = () => {
  const { toAllocateAmount } = useAppSelector(state => state.invoices)
  const { defaultCurrency } = useAppSelector(state => (state as any).settings)
  const { pricePrepend } = useGetPricePrepend({ selectedCurrency: defaultCurrency })

  return (
    <Box sx={{ width: '50%', padding: '10px 0', display: 'flex', alignItems: 'center' }}>
      <Typography data-testid="to-allocate-amount">
        To allocate: {pricePrepend}
        {setDecimalPrecision(toAllocateAmount, { decimalPrecisionOverride: 2 })}
      </Typography>
    </Box>
  )
}

export default ToAllocateAmountText
